import { render, staticRenderFns } from "./HomeJoinSocialLeague.vue?vue&type=template&id=40e69f24&scoped=true"
import script from "./HomeJoinSocialLeague.vue?vue&type=script&lang=ts"
export * from "./HomeJoinSocialLeague.vue?vue&type=script&lang=ts"
import style0 from "./HomeJoinSocialLeague.vue?vue&type=style&index=0&id=40e69f24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e69f24",
  null
  
)

export default component.exports